var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppLayout',[_c('div',{staticClass:"m-theme",style:(_vm.themeStyle)},[_c('div',{staticClass:"m-author",class:_vm.isAdmin ? 'm-author-admin' : ''},[_c('Me',{attrs:{"decorationMe":_vm.decorationMe,"honor":_vm.honor}}),_c('Footer')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }